import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Typography, Tabs, Button, Icon, Modal, DatePicker, message, Input } from "antd";
import moment from "moment";

import {
	fetchInaamCustomerComplaintListApi,
	exportCustomerComplaintsApi,
	resolveInaamCustomerComplaintsApi,
	fetchInaamCustomerComplaintCountApi,
} from "utils/apiService.js";

import CustomerComplaintsTable from "./CustomerComplaintsTable";
import Loader from "../../components/Loader/Loader";
import Empty from "./Empty";

const { TabPane } = Tabs;
const { Text } = Typography;
const { RangePicker } = DatePicker;

export default function CustomerComplaints(props) {
	const [loading, setLoading] = useState(true);
	const [tableLoading, setTableLoading] = useState(false);

	const [resolveModal, setResolveModal] = useState(false);

	const [exportReportModal, setExportReportModal] = useState(false);
	const [exportReportDate, setExportReportDate] = useState({
		start_date: null,
		end_date: null,
	});

	const [searchKey, setSearchKey] = useState("");

	const [pendingData, setPendingData] = useState({
		customerComplaints: [],
		pageNum: 1,
		pageSize: 50,
		totalPages: 1,
	});
	const [resolvedData, setResolvedData] = useState({
		customerComplaints: [],
		pageNum: 1,
		pageSize: 50,
		totalPages: 1,
	});
	const [customerComplaintsStats, setCustomerComplaintsStats] = useState({
		pending: 0,
		resolved: 0,
	});

	const [selectedRowIDs, setSelectedRowIDs] = useState([]);
	const handleRowSelection = (selectedRows) => {
		setSelectedRowIDs(selectedRows);
	};

	const activeKey = useRef("1");

	const fetchInaamCustomerComplaintsList = () => {
		setTableLoading(true);
		fetchInaamCustomerComplaintListApi({
			requestData: {
				search_key: searchKey,
				status: activeKey.current === "1" ? "unresolved" : "resolved",
				page: activeKey.current === "1" ? pendingData.pageNum : resolvedData.pageNum,
			},
			resCallback: () => {
				loading && setLoading(false);
				setTableLoading(false);
			},
			res200Callback: (res) => {
				let dataList = res.data.complaint_list?.map((data) => ({ ...data, key: data.uuid }));
				activeKey.current === "1"
					? setPendingData({ ...pendingData, customerComplaints: dataList, totalPages: res.data.total_pages })
					: setResolvedData({ ...resolvedData, customerComplaints: dataList, totalPages: res.data.total_pages });
			},
		});
		fetchInaamCustomerComplaintCountApi({
			resCallback: () => {
				loading && setLoading(false);
			},
			res200Callback: (res) => {
				setCustomerComplaintsStats({ pending: res.data?.in_queue, resolved: res.data?.resolved });
			},
		});
	};

	const createReport = () => {
		message.loading("Exporting the customer complaints...", 1);
		exportCustomerComplaintsApi({
			requestData: exportReportDate,
			resCallback: () => {
				setExportReportModal(false);
			},
			res200Callback: () => {
				message.success("Customer complaints exported successfully.", 1);
			},
			resErrorCallback: () => {
				message.error("Failed while exporting the customer complaints!", 1);
			},
		});
	};

	useEffect(() => {
		fetchInaamCustomerComplaintsList();
	}, [pendingData.pageNum, resolvedData.pageNum, searchKey]);

	return loading ? (
		<div
			style={{
				minHeight: "100vh",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				backgroundColor: "#FAFAFA",
			}}>
			<Loader />
		</div>
	) : customerComplaintsStats.pending + customerComplaintsStats.resolved === 0 ? (
		<Empty />
	) : (
		<>
			<Row
				style={{
					width: "100%",
					padding: "40px 25px 0px 25px",
					margin: "60px 0 0",
					backgroundColor: "#FAFAFA",
				}}
				gutter={[12, 48]}>
				<Row type="flex" align="middle" justify="space-between">
					<Text style={{ color: "#181818", /*fontFamily: "Gotham",*/ fontStyle: "normal", fontWeight: "bold", fontSize: "24px", lineHeight: "39px" }}>
						Customer Complaints
					</Text>
					<div style={{ display: "flex" }}>
						<Input
							style={{
								marginRight: "8px",
								width: "275px",
								border: "1px solid rgb(0, 0, 0, 0.25)",
								borderRadius: "5px",
								alignItems: "left",
							}}
							value={searchKey}
							placeholder="Search Customers Complaints"
							onChange={(e) => {
								setSearchKey(e.target.value);
								setPendingData({ ...pendingData, pageNum: 1 });
								setResolvedData({ ...resolvedData, pageNum: 1 });
							}}
							prefix={<Icon type="search" />}
							bordered={"true"}
						/>
						<Button
							onClick={() => setResolveModal(true)}
							style={{
								display: `${selectedRowIDs.length && activeKey.current === "1" ? "flex" : "none"}`,
								alignItems: "center",
								padding: "8px 16px",
								color: "#fec708",
								fontSize: "16px",
								lineHeight: "24px",
								background: "#FFFFFF",
								border: "1px solid #fec708",
								borderRadius: "5px",
								height: "40px",
								marginRight: "14px",
							}}>
							<Icon
								type="check"
								style={{
									height: "16px",
								}}
							/>
							Mark All Resolved
						</Button>
						<Modal visible={resolveModal} destroyOnClose maskClosable={false} onCancel={() => setResolveModal(!resolveModal)} footer={null}>
							<Row className="modal-row">
								<Row>
									<Icon
										type="check"
										style={{
											color: "#181818",
											fontSize: "24px",
											marginRight: "16px",
										}}
									/>
									<Text
										style={{
											fontWeight: "bold",
											color: "#181818",
											fontSize: "24px",
										}}>
										Mark All Resolved
									</Text>
								</Row>
								<Row style={{ marginTop: "30px" }}>
									<Col span={24}>
										<div>
											<Text
												style={{
													fontSize: "14px",
													color: "#181818",
												}}>
												Are You sure you want to mark all selected customer complaints as resolved?
											</Text>
										</div>
									</Col>
								</Row>
								<Row style={{ marginTop: "30px" }}>
									<Col span={24} style={{ textAlign: "right" }}>
										<Button
											onClick={() => {
												resolveInaamCustomerComplaintsApi({
													requestData: {
														uuid: selectedRowIDs,
														status: "resolved"
													},
													res200Callback: () => {
														setResolveModal(false);
														fetchInaamCustomerComplaintsList();
													},
												});
											}}
											size={"large"}
											style={{
												backgroundColor: "#fec708",
												color: "#FFFFFF",
												border: "none",
												borderRadius: "5px",
											}}>
											Mark as Resolved
										</Button>
									</Col>
								</Row>
							</Row>
						</Modal>
						{/* <Button
							onClick={() => setExportReportModal(!exportReportModal)}
							style={{
								display: "flex",
								alignItems: "center",
								padding: "8px 16px",
								color: "#FFFFFF",
								fontSize: "16px",
								lineHeight: "24px",
								background: "#fec708",
								borderRadius: "5px",
								height: "40px",
							}}>
							<Icon
								type="export"
								style={{
									height: "16px",
								}}
							/>
							Export Report
						</Button> */}
						<Modal
							visible={exportReportModal}
							destroyOnClose
							maskClosable={false}
							onCancel={() => setExportReportModal(!exportReportModal)}
							footer={null}>
							<Row className="modal-row">
								<Row>
									<Icon
										type="export"
										style={{
											color: "#181818",
											fontSize: "24px",
											marginRight: "16px",
										}}
									/>
									<Text
										style={{
											fontWeight: "bold",
											color: "#181818",
											fontSize: "24px",
										}}>
										Export Report
									</Text>
								</Row>
								<Row style={{ marginTop: "30px" }}>
									<Col span={24}>
										<div>
											<Text
												style={{
													fontSize: "14px",
													color: "#181818",
												}}>
												Select Date Range
											</Text>
											<RangePicker
												style={{
													marginTop: "5px",
													width: "100%",
													border: "1px solid rgb(0, 0, 0, 0.25)",
													borderRadius: "5px",
													alignItems: "left",
												}}
												bordered={true}
												value={[
													exportReportDate.start_date ? moment(exportReportDate.start_date, "YYYY-MM-DD") : null,
													exportReportDate.end_date ? moment(exportReportDate.end_date, "YYYY-MM-DD") : null,
												]}
												onChange={(value, dateString) => {
													setExportReportDate({ start_date: dateString[0], end_date: dateString[1] });
												}}
											/>
										</div>
									</Col>
								</Row>
								<Row style={{ marginTop: "30px" }}>
									<Col span={24} style={{ textAlign: "right" }}>
										<Button
											onClick={() => {
												createReport();
											}}
											size={"large"}
											style={{
												backgroundColor: "#fec708",
												color: "#FFFFFF",
												border: "none",
												borderRadius: "5px",
											}}>
											Export Report
										</Button>
									</Col>
								</Row>
							</Row>
						</Modal>
					</div>
				</Row>
				<Tabs
					onChange={(key) => {
						activeKey.current = key;
						fetchInaamCustomerComplaintsList();
					}}
					style={{ marginBottom: "20px" }}>
					<TabPane tab={`In Queue (${customerComplaintsStats.pending})`} key="1">
						<CustomerComplaintsTable
							data={pendingData}
							updatePage={(pageNum) => {
								pageNum === pendingData.pageNum ? fetchInaamCustomerComplaintsList() : setPendingData({ ...pendingData, pageNum: pageNum });
							}}
							loading={tableLoading}
							handleRowSelection={handleRowSelection}
						/>
					</TabPane>
					<TabPane tab={`Resolved (${customerComplaintsStats.resolved})`} key="2">
						<CustomerComplaintsTable
							data={resolvedData}
							updatePage={(pageNum) => {
								pageNum === resolvedData.pageNum ? fetchInaamCustomerComplaintsList() : setResolvedData({ ...resolvedData, pageNum: pageNum });
							}}
							loading={tableLoading}
							noAction
						/>
					</TabPane>
				</Tabs>
			</Row>
		</>
	);
}
